import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {


	    constructor() { 
    }

    ngOnInit() {
       // this.carService.getCarsSmall().then(cars => this.cars = cars);
    
    }

 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/content/content.component.ts